import { Dispatch } from 'react';
import { MeetingInformation } from '../../Components/ChimeVideoCall/meeting-call.types';
import { VideoPreview } from '../../Components/Meeting/components/participant-video-preview.types';
import { UserType } from '../../lib/video/types';

export type VideoCallContextValue = {
  videoCallState: VideoCallState;
  dispatchVideoCall: Dispatch<VideoCallActionTypes>;
  getParticipantNameBy: (userType: UserType) => string | undefined;
};

export type MediaSettings = {
  micEnabled: boolean;
  videoEnabled: boolean;
};

export type VideoCallState = {
  meetingInfo: MeetingInformation | null;
  videoPreview: VideoPreview | null;
  mediaSettings: MediaSettings;
};

export enum VideoCallActions {
  ChimeSetCallInfo = '@enara/types/chime-set-call-info',
  SetVideoPreview = '@enara/types/video-set-preview',
  ToggleMic = '@enara/types/toggle-mic',
  ToggleVideo = '@enara/types/toggle-video',
}

export type SetChimeCallInfoType = {
  type: VideoCallActions.ChimeSetCallInfo;
  payload: MeetingInformation;
};

export type SetVideoPreviewInfoType = {
  type: VideoCallActions.SetVideoPreview;
  payload: VideoPreview;
};

export type VideoCallActionTypes =
  | SetChimeCallInfoType
  | SetVideoPreviewInfoType
  | { type: VideoCallActions.ToggleMic; payload: null }
  | { type: VideoCallActions.ToggleVideo; payload: null };
